module.exports = __webpack_public_path__ + "static/homepage-our-expertise-background.ac828030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage-our-expertise-background.jpg
// module id = 507
// module chunks = 35783957827783